module.exports = __webpack_public_path__ + "static/media/3.503b2203.jpg";